import { IBlockedEmailDto } from 'api/api';
import React from 'react';
import { localizedDynamic, localizedInterpolation, i18nTranslationKey } from 'state/i18n';
import BiButton from 'view/shared/components/buttons/bi-button/bi-button';
import { DateFormatterModes, getDateToString } from 'view/shared/components/date-to-string';
import './blocked-emails.scss';

interface Props {
	item: IBlockedEmailDto;
	onUnblockClick: () => void;
}

export const BlockedEmailItem: React.FC<Props> = ({ item, onUnblockClick }) => {
	const failuresText = localizedInterpolation('blockedEmails.failures' as i18nTranslationKey, {
		count: item.failureCount,
	});
	const lastFailureText = localizedInterpolation('blockedEmails.lastFailure' as i18nTranslationKey, {
		date: getDateToString(item.blockedAt, DateFormatterModes.withMinutes),
	});
	const lastReasonText = localizedInterpolation('blockedEmails.lastReason' as i18nTranslationKey, {
		reason: item.lastFailureReason ?? '',
	});

	return (
		<div className="blocked-email-item">
			<div className="blocked-email-item-content">
				<div className="blocked-email-item-email text-bold">{item.email}</div>
				<div className="blocked-email-item-meta">{failuresText}</div>
				<div className="blocked-email-item-meta">{lastFailureText}</div>
				{item.lastFailureReason && <div className="blocked-email-item-meta">{lastReasonText}</div>}
			</div>
			<div className="blocked-email-item-action">
				<BiButton
					onClick={onUnblockClick}
					colorTheme="org-primary-grey"
					containerTheme="normal-button-corners"
				>
					<span className="text-bold">
						{localizedDynamic('blockedEmails.unblock')}
					</span>
				</BiButton>
			</div>
		</div>
	);
};

export default BlockedEmailItem;
